<template>
	<div id="data-list-list-view" class="data-list-container">
		<div class="flex flex-wrap items-center justify-between">
			<div class="flex items-center mb-2">
				<vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler mr-base">
					<div
						class="
							p-4
							border border-solid
							d-theme-border-grey-light
							rounded-full
							d-theme-dark-bg
							cursor-pointer
							flex
							items-center
							justify-between
							font-medium
						"
					>
						<span class="mr-2"
							>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
							{{
								listCompanies.length - currentPage * itemsPerPage > 0
									? currentPage * itemsPerPage
									: listCompanies.length
							}}
							of {{ queriedItems }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>
						<vs-dropdown-item @click="itemsPerPage = 12">
							<span>12</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 24">
							<span>24</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 36">
							<span>36</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage = 48">
							<span>48</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
				<vs-input icon-no-border :placeholder="$t('Search')" v-model="searchQuery" />
			</div>
			<vs-pagination :total="totalPages" :max="itemsPerPage" v-model="currentPage" />
		</div>
		<div class="vx-row mt-base">
			<div
				class="vx-col w-full sm:w-1/1 md:w-1/2 mb-base"
				:class="[
					{'lg:w-1/4': windowWidth >= 1920},
					{'lg:w-1/3': windowWidth >= 1366 && windowWidth < 1920},
					{'lg:w-1/2': windowWidth >= 1366 && windowWidth < 1366},
				]"
				:key="indextr"
				v-for="(tr, indextr) in listCompaniesPage"
			>
				<CompanyListViewItemCardVue
					:item="tr"
					:editData="editData"
					:openConfirm="openConfirm"
					:createAdminResource="createAdminResource"
					:createServiroute="createServiroute"
				/>
			</div>
		</div>
		<vs-pagination :total="totalPages" :max="itemsPerPage" v-model="currentPage" />
	</div>
</template>

<script>
import moduleCompany from "@/store/company/moduleCompany.js";
import Company from "@/models/Company.js";
import CompanyListViewItem from "./CompanyListViewItem.vue";
import CompanyListViewItemCardVue from "./CompanyListViewItemCard.vue";

export default {
	name: "CompanyListViewCard",
	components: {CompanyListViewItem, CompanyListViewItemCardVue},
	data() {
		return {
			selected: [],
			itemsPerPage: 12,
			isMounted: false,
			itemSelected: null,
			currentPageLocal: 1,
			searchQuery: null,
			//Config Resource List
			resourceListConfig: {
				rowSelection: "single",
				activeCheckbox: true,
				columns: ["id", "name", "lastname", "username", "email", "identification", "alias"],
				actionDropdown: false,
				popupMode: false,
				link: false,
				importMode: true,
			},
		};
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		listCompanies() {
			return [...this.$store.state.moduleCompany.companies].reverse();
		},
		listCompaniesPage() {
			const data = [...this.$store.state.moduleCompany.companies].reverse();
			// Calculate the index of the first item on the current page
			const startIndex = (this.currentPage - 1) * this.itemsPerPage;
			// Calculate the index of the last item on the current page
			const endIndex = startIndex + this.itemsPerPage;

			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				// Slice the contentList array to get the items for the current page
				return data.slice(startIndex, endIndex);
			} else {
				return this.listCompanies.filter((r) => {
					return r.name.toLowerCase().includes(this.searchQuery.toLowerCase());
				});
			}
		},
		queriedItems() {
			return this.listCompanies.length;
		},
		totalPages() {
			// Calculate the total number of pages
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return Math.ceil(this.listCompanies.length / this.itemsPerPage);
			} else {
				return Math.ceil(this.listCompaniesPage.length / this.itemsPerPage);
			}
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteCompany"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/removeItem", id)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyDelete"),
						text: this.$t("TextConfirmCompanyDelete"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		editData(data) {
			this.$emit("selectedCompanyEmit", new Company(data), "update");
		},
		createAdminResource(data) {
			this.$emit("selectedCompanyCreateAdminResourceEmit", data, "createAdmin");
		},
		createServiroute(data) {
			this.$emit("selectedCompanyCreateServirouteEmit", data, "createServiroute");
		},
		getOrderStatusColor(status) {
			if (status === "on_hold") return "warning";
			if (status === "delivered") return "success";
			if (status === "canceled") return "danger";
			return "primary";
		},
		getPopularityColor(num) {
			if (num > 90) return "success";
			if (num > 70) return "primary";
			if (num >= 50) return "warning";
			if (num < 50) return "danger";
			return "primary";
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
	},
	created() {
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		this.openLoading();
		this.$store
			.dispatch("moduleCompany/fetchDataListItems")
			.then((res) => {
				this.closeLoading();
			})
			.catch((err) => {
				this.closeLoading();
				console.error(err);
			});
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
